<app-admin-header></app-admin-header>
<app-header></app-header>
<div class="container top-content">
    <div class="greeting-section">
        <h1 *ngIf="userProfile && userProfile.firstName" class="name">
            Hello, {{ userProfile.firstName }}!
        </h1>
        <h1 *ngIf="userProfile && !userProfile.firstName" class="name">Hello!</h1>
        <div class="welcome">
            Welcome to PBS LearningMedia! Fill out the information below to complete your profile
            and get a customized PBS LearningMedia experience.
        </div>
    </div>

    <div class="import-classroom-callout">
        <h5 class="title">Have You Imported Your Google Classroom Class?</h5>
        <div class="content">
            Send PBS LearningMedia assignments and track your students' progress quickly and easily.
        </div>
        <app-button [routerLink]="'/tools/rosters/'">
            <img [src]="googleClassImg" alt="google classroom icon" />
            Import
        </app-button>
    </div>
</div>
<div class="container">
    <div class="profile-info-wrapper">
        <h2 class="your-profile">Your Profile</h2>
        <h4>Site Preferences</h4>
        <div class="site-pref-description">
            Your selections, including your local station, will enable us to surface relevant state
            standards and grade-appropriate resources.
        </div>

        <div class="local-station-wrapper">
            <div class="label-wrapper">
                <span class="label">Your Local Station:</span>
                <span class="content">
                    <img *ngIf="localizationLogo" [src]="localizationLogo" alt="" />
                    <span *ngIf="!localizationLogo">Not localized</span>
                </span>
            </div>

            <div class="label-wrapper">
                <span class="label">State Standards:</span>
                <span class="content">{{
                    this.stateStandards ? this.stateStandards : "None"
                }}</span>
            </div>

            <div class="label-wrapper">
                <span class="label">School ZIP Code:</span>
                <span class="content">{{ zipCode }}</span>
            </div>

            <div class="change-station" (click)="openLocalizationChangeModal()">
                <app-icon [type]="'Cog'"></app-icon>
                Change your local station
            </div>
        </div>

        <div class="checkboxes-panels">
            <div class="grades-panel">
                <div class="title">Grade(s)</div>
                <div class="checkboxes">
                    <div class="checkbox" *ngFor="let item of gradesCheckboxesModel">
                        <app-input-box
                            label="{{ item.label }}"
                            inputType="checkbox"
                            [inputModel]="item.checkValue"
                            (inputModelChange)="
                                changeCheckboxesModel($event, item, gradesCheckboxesModel)
                            "
                        >
                        </app-input-box>
                    </div>
                </div>
            </div>
            <div class="subjects-panel">
                <div class="title">Subjects</div>
                <div class="checkboxes">
                    <div class="checkbox" *ngFor="let item of subjectsCheckboxModel">
                        <app-input-box
                            label="{{ item.label }}"
                            inputType="checkbox"
                            [inputModel]="item.checkValue"
                            (inputModelChange)="
                                changeCheckboxesModel($event, item, subjectsCheckboxModel)
                            "
                        >
                        </app-input-box>
                    </div>
                </div>
            </div>
        </div>
        <div class="user-info-wrapper">
            <h4>User Information</h4>
            <div *ngIf="userProfile" class="personal-info">
                <app-input-box
                    label="First Name"
                    inputType="text"
                    class="selenium-input-firstname"
                    [(inputModel)]="userProfile.firstName"
                ></app-input-box>
                <app-input-box
                    label="Last Name"
                    inputType="text"
                    class="selenium-input-lastname"
                    [(inputModel)]="userProfile.lastName"
                ></app-input-box>
            </div>
            <div *ngIf="userProfile" class="account-info">
                <div>
                    <div class="label">Email</div>
                    <div class="content">
                        {{ userProfile ? userProfile.email : "" }}
                    </div>
                    <a
                        class="open-user-info-edit"
                        *ngIf="userProfile.hasPBSAccount"
                        [href]="getAccountEditLink()"
                        (click)="updateProfile()"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Change Email
                        <app-icon [type]="'External-link'"></app-icon>
                    </a>
                </div>

                <div>
                    <div class="label">Password</div>
                    <div class="content">************</div>
                    <div
                        class="open-user-info-edit"
                        *ngIf="userProfile.hasPBSAccount"
                        (click)="clickChangePassword()"
                    >
                        Change Password
                        <app-icon [type]="'External-link'"></app-icon>
                    </div>
                </div>
            </div>
        </div>
        <div class="professional-info-wrapper">
            <h4>Professional Information</h4>
            <div class="professional-info">
                <div class="professional-info-desc">
                    We're always looking to improve the PBS LearningMedia experience! The
                    information you provide here will help us with future enhancements to our
                    communications and website.
                </div>
                <div class="selectors-wrapper">
                    <app-school-selector
                        [items]="schools"
                        [(selectedItem)]="selectedSchool"
                    ></app-school-selector>
                    <app-role-selector
                        [items]="roles"
                        [(selectedItem)]="selectedRole"
                    ></app-role-selector>
                </div>
                <div class="add-school-action-link">
                    <button (click)="openAddSchoolModal()">Can't find your school?</button>
                </div>
            </div>
        </div>
        <div class="update-profile-wrapper">
            <app-button (click)="updateProfile(); openProfileUpdateConfirmationModal()"
                >Update Profile</app-button
            >
        </div>
    </div>
</div>
<app-available-features></app-available-features>
<app-footer></app-footer>
<app-simplified-footer></app-simplified-footer>
